<template>
  <TaskLogItem
    v-for="item in items"
    :key="item.id"
    :item="item"
    :type="type"
    :canDelete="canDelete"
    :class="props.class"
    @delete="handleDelete(item)"
  />
  <DeleteModal
    v-model:open="openConfirmModal"
    :title="
      type === 'time'
        ? $t('components.logged_time.delete.confirm.title')
        : $t('components.logged_material.delete.confirm.title')
    "
    :description="
      type === 'time'
        ? $t('components.logged_time.delete.confirm.description')
        : $t('components.logged_material.delete.confirm.description')
    "
    @delete="handleConfirm"
  />
</template>

<script setup>
import { ref } from "vue";
import { DeleteModal } from "@/SharedComponents/Modals";
import { TaskLogItem } from "@/SharedComponents/Tasks/TaskDetailsParts";

const emit = defineEmits(["delete"]);

const props = defineProps({
  items: { type: Array, required: true },
  type: {
    type: String,
    validator: (value) => ["time", "material"].includes(value),
    required: true,
  },
  canDelete: { type: Boolean, required: false },
  class: { type: null, required: false },
});

const itemToDelete = ref(null);
const openConfirmModal = ref(false);

function handleDelete(item) {
  itemToDelete.value = item;
  openConfirmModal.value = true;
}

function handleConfirm() {
  emit("delete", itemToDelete.value);
  itemToDelete.value = null;
}
</script>
